import { render } from "./Button.vue?vue&type=template&id=44f82e3b&scoped=true"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"

import "./Button.vue?vue&type=style&index=0&id=44f82e3b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-44f82e3b"

export default script